type LogoProps = {
  className?: string;
  title?: string;
};

/**
 * Jednobarevné vektorové logo: kruhový talíř + vidlička (vlevo) a lžíce (vpravo).
 * Vykresluje se v `currentColor`, takže barvu lze řídit přes Tailwind (`text-brand-700` atp.).
 */
export function Logo({ className = "w-7 h-7", title = "Jedalniček" }: LogoProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <title>{title}</title>
      <circle cx="32" cy="32" r="16" />
      <circle cx="32" cy="32" r="10" strokeWidth={2.5} />

      <line x1="14" y1="10" x2="14" y2="18" />
      <line x1="10" y1="10" x2="10" y2="18" />
      <line x1="18" y1="10" x2="18" y2="18" />
      <line x1="14" y1="18" x2="14" y2="54" />

      <ellipse cx="50" cy="16" rx="5" ry="7" strokeWidth={3.5} />
      <line x1="50" y1="23" x2="50" y2="54" />
    </svg>
  );
}
